import { render, staticRenderFns } from "./subsidary-detail.vue?vue&type=template&id=6e405eb2&lang=pug"
import script from "./subsidary-detail.vue?vue&type=script&lang=js"
export * from "./subsidary-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports